import { Component } from '@angular/core';
import {   NavController, NavParams } from 'ionic-angular';



@Component({
  selector: 'page-banka-havale-eft',
  templateUrl: 'banka-havale-eft.html',
})
export class BankaHavaleEftPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BankaHavaleEftPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/BankaIslemleri/banka-havale-eft/banka-havale-eft.ts